import { MouseEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import { RootState } from 'src/store/store'
import { setModalItems } from 'src/store/Reducer/common/modalSlice'
import { useAppDispatch } from 'src/hooks/redux/useAppDispatch'
type UsePromptHookType = {
  PromptNavLinkHandler: (e: MouseEvent<HTMLAnchorElement>, path: string) => void
}

export function usePromptHook(when: boolean): UsePromptHookType {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const { CameraStatus } = useAppSelector((state: RootState) => state.CameraPage)

  const PromptNavLinkHandler = (e: MouseEvent<HTMLAnchorElement>, path: string) => {
    const handlePageChange = (e: MouseEvent<HTMLAnchorElement>) => {
      if (when && e.currentTarget.href !== undefined) {
        e.preventDefault()
      }
    }
    if (CameraStatus !== 'default') {
      handlePageChange(e)
      dispatch(
        setModalItems({
          type: 'confirm',
          text: 'Would you like to end the video call and exit?',
          confirmFunc: () => navigate(path),
        }),
      )
    } else return
  }

  return { PromptNavLinkHandler }
}

export default usePromptHook
